import { css } from '@emotion/react'
import Link from 'next/link'
import { styled } from 'styles/styled'
import { theme } from 'styles/theme'

interface DimmedBackgroundProps {
  $isVisible?: boolean
}

export const DimmedBackground = styled.div<DimmedBackgroundProps>`
  ${({ $isVisible }) =>
    $isVisible &&
    `& + div {
      &:before {
        content: '';
        position: fixed;
        width: 100%;
        z-index: 92;
        inset: 0;
        background-color: rgba(40, 45, 45, 0.8);
      }
    }
    `};
`

interface Level2CategoryLinkProps {
  $isSelected?: boolean
}
export const Level2CategoryLink = styled(Link)<Level2CategoryLinkProps>`
  padding: 6px 12px;
  text-decoration: none;
  flex-shrink: 0;
  border: 1px solid ${theme.palette.surface.tertiary};
  border-radius: 12px;
  box-sizing: border-box;
  background-color: white;
  transition: 0.3s;
  ${({ $isSelected }) =>
    $isSelected &&
    css`
      border: 1px solid ${theme.palette.label.default};
      background-color: ${theme.palette.surface.secondary};
    `};
  :hover {
    border: 1px solid ${theme.palette.label.default};
    background-color: ${theme.palette.surface.secondary};
  }
`
